import { createContext } from 'react';
var TranslationContext = createContext({
    locale: 'en',
    setLocale: function () { return Promise.resolve(); },
    i18nProvider: {
        translate: function (x) { return x; },
        changeLocale: function () { return Promise.resolve(); },
        getLocale: function () { return 'en'; },
    },
});
TranslationContext.displayName = 'TranslationContext';
export { TranslationContext };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/i18n/TranslationContext.js
// module id = 66
// module chunks = 0